export const nodeHeight = 76;
export const nodeWidth = 200;
